import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ChatService} from '../../../service/chat/chat-service';
import {Sessioncommand} from '../../../global/sessioncommand';
import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../environments/environment';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import {language} from '../../../language/vn';
import {WebSocketService} from '../../../service/chat/websocket-service';
import {UsersService} from '../../../service/staff/service-users';
import {Users} from '../../../models/staff/users';
import {ChatMessage} from '../../../models/chat/chatmessage';
import {ChatMessageService} from '../../../service/chat/service-chatmessage';
import {ConfigQuestionService} from '../../../service/chat/configquestion-service';
import {ConfigQuestion} from '../../../models/chat/configquestion';
import {EditKeHoachComponent} from '../kehoach/edit.component';
import {ConfigChatComponent} from './configchat.component';
import {BsModalService} from 'ngx-bootstrap/modal';


@Component({
  selector: 'egov-chat-online',
  templateUrl: './chat.component.html',
  styleUrls: ['./css/css.css']


})
export class ChatComponent implements OnInit, AfterViewInit {
  public message: string;
  public messageSend: string;
  public messageQuestionSend: string;
  @ViewChild('contentChat') chatMain: ElementRef;
  @ViewChild('contentChatQuestion') contentChatQuestion: ElementRef;
  @ViewChild('chatLeft') chatLeft: ElementRef;
  @ViewChild('chatRight') chatRight: ElementRef;
  public showChat: boolean = false;
  public staffLeft: Staffs= new Staffs();
  public language = language;
  public searchKey: string = '';
  public userList: Users[] = [];
  public messageTotal: number =0 ;
  public receiveUrl: string= environment.chatReceiveUrl;
  public sendUrl: string= environment.chatSendUrl;
  public addUrl: string= environment.chatAddUrl;
  public stompClient: any ;
  public chatMessage: ChatMessage = new ChatMessage();
  public sessionChat: String ="" ;
  public  selectId: number = 0;
  public  mainId: number = 0;
  public  chatShow: boolean = true;
  public  messageQuestion: string = "";
  constructor( public staffsService: StaffsService,
               public datepipe: DatePipe,
               public configQuestionService: ConfigQuestionService,
               public usersService: UsersService,
               public bsModalService: BsModalService,
               public chatMessageService: ChatMessageService,
               public webSocketService: WebSocketService) {
    // this.stompClient = this.webSocketService.connect();

  }
  ngAfterViewInit() {
    this.staffsService.getById(Sessioncommand.staffId).subscribe(data => {
      this.staffLeft= data;
    });
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public edit(id: number) {


  }
  public searchUser()
  {
    this.usersService.findAllByKeyAndUID(this.searchKey, Sessioncommand.userId).subscribe(
      data=> this.userList = data
    );
  }
  public showFormChat()
  {
    this.showChat = !this.showChat;
    if(this.showChat == true)
      document.getElementById("chatAlertMessage").setAttribute("style","display:none");
    document.getElementById("chatIdForm").setAttribute("style",this.showChat==true? "": "display:none");
  }
  public setChat(uId: number)
  {
    this.mainId = uId;
      this.chatMessageService.getByUIdAndRId(Sessioncommand.userId, uId).subscribe(
        x=> {
          if(this.stompClient!=null)
            this.stompClient.disconnect();
          this.sessionChat = x.id.toString();
          this.stompClient = this.webSocketService.connect();
            this.connect();
        }
      );

  }
  connect() {
       this.stompClient.connect({}, frame => {
        this.stompClient.subscribe(this.receiveUrl + this.sessionChat, this.onMessageReceived);
      });
    this.stompClient.send(this.addUrl+ this.sessionChat, {},  JSON.stringify({sender: Sessioncommand.userId, sessionChat: this.sessionChat, type: 'JOIN'}));
  }
  ngOnInit(): void {

  }
  send(message: String) {
    let bodyMessage: Object = {
      sender: Sessioncommand.userId,
      sessionChat: this.sessionChat,
      content: message,
      type: 'CHAT',
      fullName: this.staffLeft.fullName.trim(),
      name: this.staffLeft.ten.trim()
    };

    this.stompClient.send(this.sendUrl + this.sessionChat, {}, JSON.stringify(bodyMessage));
  }
  public helpQuestion(): void {
    const modalEdit = this.bsModalService.show(ConfigChatComponent, {class: 'modal-lg'});
    (<ConfigChatComponent>modalEdit.content).show(

    );
    (<ConfigChatComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public sendMessage()
  {
    this.send(this.message);
    this.messageSend = this.chatLeft.nativeElement.innerHTML
      .replaceAll('***NAME_LEFT***', this.staffLeft.ten.substr(0, 1))
      .replaceAll('***egov-content-message-left***', this.message)
      .replaceAll('***egov-time-message-left***', this.datepipe.transform(new Date(), 'dd/MM/yyyy HH:mm').toString());
    this.chatMain.nativeElement.insertAdjacentHTML('beforeend', this.messageSend );
    this.message= '';
  }
  public sendQuestion()
  {
    this.messageSend = this.chatLeft.nativeElement.innerHTML
        .replaceAll('***NAME_LEFT***', this.staffLeft.ten.substr(0, 1))
        .replaceAll('***egov-content-message-left***', this.messageQuestion)
        .replaceAll('***egov-time-message-left***', this.datepipe.transform(new Date(), 'dd/MM/yyyy HH:mm').toString());
    this.contentChatQuestion.nativeElement.insertAdjacentHTML('beforeend', this.messageSend );
    this.configQuestionService.findByQuestion(this.messageQuestion).subscribe( data =>
    {
      let ms: string = document.getElementById("chatContentRight").innerHTML
          .replace('***NAME_RIGHT***', "HT")
          .replace('***egov-content-message-right***', (data.status === false? language.not_get_question : data.content))
          .replace('***egov-fullname-message-right***', language.hethong)
          .replace('***egov-time-message-right***', new DatePipe("en-US").transform(new Date(), 'dd/MM/yyyy HH:mm').toString())
      document.getElementById("chatContentQuestion").insertAdjacentHTML('beforeend', ms );
    });

    this.messageQuestion= '';
  }
  onMessageReceived(message)
  {
    let contentReceive: any = (JSON.parse(message.body));

    if(contentReceive.sender != Sessioncommand.userId)
    {
         let ms: string = document.getElementById("chatContentRight").innerHTML
        .replace('***NAME_RIGHT***', contentReceive.name.substr(0, 1))
        .replace('***egov-content-message-right***', contentReceive.content.toString())
        .replace('***egov-time-message-right***', new DatePipe("en-US").transform(new Date(), 'dd/MM/yyyy HH:mm').toString())
        .replace('***egov-fullname-message-right***', contentReceive.fullName.toString());
        document.getElementById("chatContentMain").insertAdjacentHTML('beforeend', ms );
         let st: string = document.getElementById("chatIdForm").getAttribute("style");
        if(st == 'display:none') {
          document.getElementById("chatAlertMessage").innerText = "1";
          document.getElementById("chatAlertMessage").setAttribute("style","");
        }
    }
  }
}

